import React from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { CHART_PALETTE } from '../../../theme/chartColors';

const ScatterRenderer = ({ data, config, compact }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <div className="dc-no-data">No scatter data available</div>;
  }

  const { xKey, yKeys = [], colors = CHART_PALETTE, showGrid = true } = config || {};
  
  // Robust detection
  const actualXKey = data[0][xKey] !== undefined ? xKey : Object.keys(data[0]).find(k => typeof data[0][k] === 'string') || 'name';
  const actualYKey = data[0][yKeys[0]] !== undefined ? yKeys[0] : Object.keys(data[0]).find(k => typeof data[0][k] === 'number') || 'value';

  const isXNumeric = typeof data[0][actualXKey] === 'number';

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ScatterChart margin={compact ? { top: 0, right: 10, left: 40, bottom: 80 } : { top: 10, right: 30, left: 50, bottom: 120 }}>
        {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="var(--border-primary)" />}
        <XAxis 
          type={isXNumeric ? 'number' : 'category'} 
          dataKey={actualXKey} 
          name={actualXKey} 
          interval={0}
          angle={-45}
          textAnchor="end"
          height={compact ? 80 : 130}
          tick={{ fontSize: compact ? 10 : 12, fill: 'var(--text-tertiary)' }} 
          axisLine={false} 
          tickLine={false} 
        />
        <YAxis 
          type="number" 
          dataKey={actualYKey} 
          name={actualYKey} 
          tick={{ fontSize: compact ? 10 : 12, fill: 'var(--text-tertiary)' }} 
          axisLine={false} 
          tickLine={false} 
        />
        <Tooltip cursor={{ strokeDasharray: '3 3' }} contentStyle={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-primary)', borderRadius: '8px' }} />
        
        <Scatter name="Data" data={data} fill={colors[0]}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default ScatterRenderer;
